import { buildStandardMeta } from '../../types/builders';
export var SCHEDULE_PAGE = {
    tags: [buildStandardMeta('robots', 'noindex')],
};
